import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { NoContentResponse } from '@/types/api'
import {
  CreateUserInviteRequest,
  GetUserInvitesParams,
} from '@/types/requests/invite-users'
import {
  AcceptUserInviteResponse,
  InviteUserCollection,
  InviteUserItem,
} from '@/types/responses/invite-users'

class InviteCompanyUserService {
  private readonly endpoint = `${API_PATH_INTERNAL}/invite-users`

  async getUserInvites(
    params: GetUserInvitesParams,
  ): Promise<InviteUserCollection> {
    const response = await apiService.get<InviteUserCollection>(this.endpoint, {
      params,
    })

    return response.data
  }

  async getUserInvite(
    inviteId: number,
    inviteCode: string,
  ): Promise<InviteUserItem> {
    const response = await apiService.get<InviteUserItem>(
      `${this.endpoint}/${inviteId}`,
      { params: { code: inviteCode } },
    )

    return response.data
  }

  async createUserInvite(
    request: CreateUserInviteRequest,
  ): Promise<InviteUserItem> {
    const response = await apiService.post<InviteUserItem>(
      this.endpoint,
      request,
    )

    return response.data
  }

  async cancelUserInvite(inviteId: number): Promise<NoContentResponse> {
    const response = await apiService.delete<NoContentResponse>(
      `${this.endpoint}/${inviteId}`,
    )

    return response.data
  }

  async acceptUserInvite(
    inviteId: number,
    inviteCode: string,
  ): Promise<AcceptUserInviteResponse> {
    const response = await apiService.patch<InviteUserItem>(
      `${this.endpoint}/${inviteId}`,
      {},
      { params: { code: inviteCode } },
    )

    return response.data
  }

  async resendUserInvite(inviteId: number): Promise<unknown> {
    const response = await apiService.post(
      `${this.endpoint}/${inviteId}/resend-invite`,
      {},
    )

    return response.data
  }
}

const inviteCompanyUserService = new InviteCompanyUserService()

export default inviteCompanyUserService
